import { toast } from "sonner";

export function downloadImportErrors(errors, base, user) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = ["line,error", ...errors.map((e) => `${esc(e.line)},${esc(e.error)}`)];
  const url = URL.createObjectURL(new Blob([lines.join("\n")], { type: "text/csv" }));
  const a = document.createElement("a");
  const d = new Date();
  const stamp = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
  const who = user ? `${(user.first_name || "").toLowerCase()}-${(user.last_name || "").toLowerCase()}`.replace(/^-|-$/g, "") : "export";
  a.href = url;
  a.download = `${base}-errors-${stamp}-${who || "export"}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function reportImportErrors(data, base, user) {
  const errs = (data?.errors || []).filter((e) => e && e.error);
  if (!errs.length) return false;
  downloadImportErrors(errs, base, user);
  toast.warning(`${errs.length} row(s) failed — error file downloaded`);
  return true;
}
